import { StyleDeclarationValue, css } from 'aphrodite';

interface IProps {
	styles?: StyleDeclarationValue[];
}

export const TurningXXTriggerGraphic = ({ styles = [] }: IProps) => {
	return (
		<svg
			width='172'
			height='172'
			viewBox='0 0 172 172'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${css(...styles)}`}
		>
			<g filter='url(#filter0_d_0_4899)'>
				<circle cx='86' cy='86' r='80' fill='url(#paint0_linear_0_4899)' />
			</g>
			<mask
				id='mask0_0_4899'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='6'
				y='6'
				width='160'
				height='160'
			>
				<circle cx='86' cy='86' r='80' fill='white' />
			</mask>
			<g mask='url(#mask0_0_4899)'>
				<path
					d='M163 22.3564C160.91 23.6728 158.812 24.9362 156.705 26.1464C156.553 26.2344 156.4 26.3225 156.248 26.4084C153.628 27.9051 150.997 29.3166 148.356 30.6429C148.225 30.7099 148.093 30.7749 147.963 30.8399C143.556 33.041 139.133 35.0038 134.695 36.7283C134.544 36.787 134.394 36.8457 134.244 36.9023C131.497 37.9588 128.749 38.9217 125.999 39.7909C125.851 39.837 125.701 39.8852 125.552 39.9293C125.383 39.9838 125.213 40.0362 125.043 40.0886C120.405 41.518 115.69 42.6972 110.919 43.6208C110.743 43.6543 110.569 43.6878 110.395 43.7214C107.15 44.3335 103.895 44.8226 100.63 45.1887C100.481 45.2076 100.335 45.2244 100.187 45.2391C95.5478 45.7455 90.8831 45.9996 86.2148 46C75.2063 46 63.9614 44.5787 52.7102 41.7698C52.5492 41.7299 52.3881 41.6901 52.227 41.6461C50.3285 41.1681 48.4293 40.649 46.5294 40.0886C45.3375 39.7364 44.142 39.3682 42.9429 38.9838C42.799 38.9377 42.6551 38.8916 42.5112 38.8434C37.4128 37.1936 32.2793 35.2511 27.1108 33.0158C26.9541 32.9487 26.7973 32.8796 26.6383 32.8104C23.5265 31.4562 20.4075 29.9972 17.2813 28.4334C17.1481 28.3684 17.015 28.3013 16.8819 28.2322C13.2567 26.4126 9.62945 24.4554 6 22.3606L6.21895 22C9.97515 24.1675 13.7242 26.1848 17.4659 28.0519L17.4767 28.0561C20.4963 29.5654 23.5108 30.9754 26.5202 32.2863C31.7382 34.5681 37.071 36.5908 42.4983 38.3466C42.857 38.4619 43.2135 38.5772 43.5721 38.6862C46.6003 39.6421 49.6234 40.4952 52.6414 41.2457C52.8047 41.2876 52.9658 41.3275 53.1289 41.3673C68.9332 45.2537 84.5512 46.3766 99.983 44.736C100.131 44.7234 100.277 44.7066 100.425 44.6877C103.499 44.3544 106.563 43.9086 109.617 43.3503C110.143 43.2539 110.67 43.1554 111.196 43.0506C115.926 42.1283 120.601 40.9547 125.2 39.5352C125.348 39.489 125.499 39.4429 125.647 39.3947C128.54 38.4954 131.423 37.4941 134.297 36.3908C134.448 36.3321 134.598 36.2755 134.748 36.2168C139.076 34.5419 143.382 32.6385 147.666 30.5066C147.797 30.4437 147.928 30.3787 148.059 30.3096C150.817 28.9323 153.564 27.4594 156.302 25.8907C156.456 25.8047 156.609 25.7167 156.761 25.6265C158.769 24.4694 160.771 23.262 162.768 22.0042L163 22.3564Z'
					fill='#F2F2F2'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M18.2848 27.2566L27.9241 31.7995L29 32.306L28.5536 32.5829L15 41L17.6508 27.4457L17.7377 27L18.2733 27.2521L18.2848 27.2566ZM18.0765 27.6618L15.6501 40.0635L28.0499 32.3623L28.0545 32.36L18.0765 27.6573V27.6618Z'
					fill='#F2F2F2'
				/>
				<path
					d='M53.5414 42.1386L53.1516 42.5721L44.6909 51.9425L44.4181 39.6899L44.4081 39.2088L45.0101 39.3676C44.6727 39.2496 44.3374 39.1248 44 39L44.0121 39.5379L44.3111 53L53.6061 42.7059L54 42.2702C53.8465 42.2271 53.695 42.184 53.5414 42.1386Z'
					fill='#F2F2F2'
				/>
				<path
					d='M109.592 44.3135L110.496 44.1886L110.286 44.7016L105.252 56.8971L101.577 46.2365L101.395 45.7125C101.262 45.7322 101.132 45.7497 101 45.7629L101.182 46.2891L105.221 58L110.753 44.5964L111 44C110.531 44.1096 110.061 44.2127 109.592 44.3135Z'
					fill='#F2F2F2'
				/>
				<path
					d='M135.528 36.1801L135.471 36.7097L134.291 47.9583L126.837 39.7003L126.468 39.2902C126.313 39.3401 126.155 39.3878 126 39.4356L126.369 39.8436L134.632 49L135.944 36.5295L136 36C135.843 36.0608 135.685 36.1194 135.528 36.1801Z'
					fill='#F2F2F2'
				/>
				<path
					d='M157.545 25.2738L157.492 25.8105L156.259 37.957L149.682 30.1998L149.389 29.8543C149.259 29.926 149.13 29.9933 149 30.0585L149.293 30.404L156.58 39L157.945 25.5389L158 25C157.849 25.0934 157.698 25.1847 157.545 25.2738Z'
					fill='#F2F2F2'
				/>
				<path
					d='M101.873 102.61C99.2445 100.371 97.6476 96.8344 98.0664 93.3913C98.4852 89.9482 101.079 86.7829 104.443 86.0517C107.808 85.3206 111.643 87.3445 112.665 90.657C113.227 84.2707 113.875 77.6169 117.244 72.1784C120.294 67.2539 125.578 63.7303 131.304 63.1C137.03 62.4696 143.058 64.8504 146.629 69.4054C150.2 73.9604 151.075 80.5824 148.574 85.8119C146.731 89.6643 143.337 92.5313 139.78 94.8638C128.288 102.337 114.504 105.376 100.965 103.422L101.873 102.61Z'
					fill='#EFDAFF'
				/>
				<path
					d='M141.036 65.1303C136.23 68.9803 131.82 73.2863 127.871 77.986C121.691 85.3157 116.69 93.5337 113.043 102.354C112.776 102.997 113.838 103.277 114.102 102.641C120.07 88.3066 129.598 75.6726 141.813 65.8943C142.362 65.455 141.58 64.6946 141.036 65.1303V65.1303Z'
					fill='white'
				/>
				<path
					d='M46 137.419C45.4649 137.499 44.9283 137.57 44.3903 137.633C31.3652 139.128 18.2287 136.028 7.21268 128.861C3.65929 126.529 0.266456 123.662 -1.57436 119.808C-4.07459 114.579 -3.19913 107.957 0.369305 103.402C1.66843 101.758 3.26949 100.381 5.08495 99.3474C5.35472 99.1898 5.62866 99.043 5.9069 98.9026C8.92739 97.3702 12.32 96.7431 15.683 97.0955C21.4047 97.726 26.6856 101.252 29.7337 106.174C33.0987 111.613 33.7473 118.267 34.3081 124.653C34.3531 124.506 34.4045 124.362 34.4601 124.221C34.5786 123.92 34.7218 123.63 34.8882 123.353V133.963C34.8904 135.75 36.3267 137.199 38.0991 137.201H45.7559L46 137.419Z'
					fill='#EFDAFF'
				/>
				<path
					d='M5.96373 99.1303C10.7705 102.98 15.1802 107.286 19.129 111.986C23.0784 116.681 26.5555 121.741 29.5114 127.096C31.1635 130.1 32.6477 133.191 33.9573 136.354C34.2243 136.997 33.1618 137.277 32.8978 136.641C30.5782 131.064 27.7084 125.725 24.3296 120.699C20.9672 115.691 17.1188 111.016 12.8384 106.739C10.4174 104.321 7.86297 102.036 5.18679 99.8943C4.63825 99.455 5.41972 98.6946 5.96372 99.1303H5.96373Z'
					fill='white'
				/>
				<path
					d='M109.922 114.667H53.1562V108.167C53.1562 106.97 52.2258 106 51.0781 106C49.9304 106 49 106.97 49 108.167V116.833C49.0033 118.029 49.9318 118.997 51.0781 119H109.922C111.07 119 112 118.03 112 116.833C112 115.637 111.07 114.667 109.922 114.667Z'
					fill='#F2F2F2'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M24.6734 138H146.327C148.354 138.003 149.997 139.613 150 141.6V152.4C149.997 154.387 148.354 155.997 146.327 156H24.6734C22.6458 155.997 21.0029 154.387 21 152.4V141.6C21.0029 139.613 22.6458 138.003 24.6734 138ZM146.327 155.576C148.116 155.574 149.566 154.153 149.568 152.4V141.6C149.566 139.847 148.116 138.426 146.327 138.424H24.6734C22.8842 138.426 21.4343 139.847 21.4322 141.6V152.4C21.4343 154.153 22.8842 155.574 24.6734 155.576H146.327Z'
					fill='#3F3D56'
				/>
				<path
					d='M139.958 148.667H28.0838V142.167C28.0838 140.97 27.1696 140 26.0419 140C24.9142 140 24 140.97 24 142.167V150.833C24.0033 152.029 24.9156 152.997 26.0419 153H139.958C141.086 153 142 152.03 142 150.833C142 149.637 141.086 148.667 139.958 148.667V148.667Z'
					fill='#F2F2F2'
				/>
				<path
					d='M119.959 129.667H42.0818V123.167C42.0818 121.97 41.1681 121 40.0409 121C38.9138 121 38 121.97 38 123.167V131.833C38.0033 133.029 38.9151 133.997 40.0409 134H119.959C121.086 134 122 133.03 122 131.833C122 130.637 121.086 129.667 119.959 129.667Z'
					fill='#F2F2F2'
				/>
				<path
					d='M128.077 143.996C110.813 139.633 74.125 145.741 73.4776 145.741C72.8453 145.741 32.7091 151.772 34.032 137.436C34.045 137.292 34.0622 137.148 34.0838 137H141.822C141.848 137.129 141.874 137.275 141.898 137.436C142.314 140.279 142.109 147.542 128.077 143.996Z'
					fill='#6E27A3'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M38.6894 120H133.311C135.347 120.003 136.997 121.613 137 123.6V134.4C136.992 136.385 135.345 137.993 133.311 138H38.6894C36.6537 137.995 35.0047 136.386 35 134.4V123.6C35.0029 121.613 36.653 120.003 38.6894 120ZM133.311 137.576C135.107 137.573 136.562 136.153 136.566 134.4V123.6C136.564 121.847 135.108 120.426 133.311 120.424H38.6894C36.8924 120.426 35.4362 121.847 35.434 123.6V134.4C35.4376 136.153 36.893 137.573 38.6894 137.576H133.311Z'
					fill='#3F3D56'
				/>
				<path
					d='M120.882 126.296C105.855 122.37 73.9236 127.867 73.3601 127.867C72.8098 127.867 37.8764 133.295 39.0278 120.393C39.0391 120.263 39.0541 120.133 39.0729 120H132.845C132.868 120.116 132.89 120.247 132.911 120.393C133.274 122.951 133.095 129.488 120.882 126.296Z'
					fill='#6E27A3'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M49.6061 119H119.394C121.385 118.998 122.998 117.387 123 115.4V104.6C122.998 102.613 121.385 101.002 119.394 101H49.6061C47.6154 101.002 46.0022 102.613 46 104.6V115.4C46.0022 117.387 47.6154 118.998 49.6061 119ZM46.4242 104.6C46.4262 102.847 47.8496 101.426 49.6061 101.424H119.394C121.15 101.426 122.574 102.847 122.576 104.6V115.4C122.574 117.153 121.15 118.574 119.394 118.576H49.6061C47.8496 118.574 46.4262 117.153 46.4242 115.4V104.6Z'
					fill='#3F3D56'
				/>
				<path
					d='M112.718 106.197C101.208 103.58 76.75 107.244 76.3184 107.244C75.8969 107.244 49.1394 110.863 50.0213 102.262C50.03 102.175 50.0415 102.089 50.0559 102H121.881C121.899 102.077 121.916 102.165 121.932 102.262C122.21 103.967 122.073 108.325 112.718 106.197Z'
					fill='#6E27A3'
				/>
				<ellipse cx='85.5' cy='102.5' rx='7.5' ry='0.5' fill='#3F3D56' />
				<path
					d='M85 78C84.9723 78 84.95 77.9082 84.95 77.7949V70.2051C84.95 70.0918 84.9723 70 85 70C85.0276 70 85.05 70.0918 85.05 70.2051V77.7949C85.05 77.9082 85.0276 78 85 78Z'
					fill='#3F3D56'
				/>
				<path
					d='M89.2671 69.3754C91.2917 71.1765 88.7672 75 86.0038 75C83.2403 75 81 72.8548 81 70.2087C81 67.5625 86.4081 55.8895 85.3511 58.3345C85.0137 59.1149 86.9485 67.3127 89.2671 69.3754Z'
					fill='#F3CE0D'
				/>
				<path
					d='M87.1346 101H83.8654C83.3877 100.999 83.0005 100.582 83 100.068V78.9324C83.0005 78.4177 83.3877 78.0006 83.8654 78H87.1346C87.6123 78.0006 87.9995 78.4177 88 78.9324V100.068C87.9995 100.582 87.6123 100.999 87.1346 101V101Z'
					fill='white'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_0_4899'
					x='0'
					y='0'
					width='172'
					height='172'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feGaussianBlur stdDeviation='3' />
					<feColorMatrix type='matrix' values='0 0 0 0 0.544244 0 0 0 0 0.544244 0 0 0 0 0.544244 0 0 0 0.100034 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_0_4899' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_0_4899' result='shape' />
				</filter>
				<linearGradient
					id='paint0_linear_0_4899'
					x1='7.55055'
					y1='6'
					x2='7.55055'
					y2='162.899'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#BDA8EB' />
					<stop offset='1' stopColor='#EDDEFF' />
				</linearGradient>
			</defs>
		</svg>
	);
};
